<template>
    <div class="journey-container" @click="(evt) => {handleMenuState(evt)}">
      <Journey v-show="selectedJourney && showJourney"></Journey>
      <Journeys v-show="showJourneys"></Journeys>
    </div>
</template>
<style lang="less" scoped>
  .journey-container {
    position: absolute;
    z-index: 1000;
    width: 100%;
    min-height: 100%;
    left: 0;
    top: 0;
    background: #222;
    .fade-enter-active {
      transition: opacity 1s;
    }
    .fade-leave-active {
      transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to, .fade-leave-active {
      opacity: 0;
    }
  }
</style>
<script>
  import Journey from "@/journeys/Journey";
  import Journeys from "@/journeys/Journeys";
  import { mapGetters, mapState } from "vuex";
  export default {
    components: {Journeys, Journey},
    computed: {
      showJourneys() {
        return showJourneys && ((this.currentUser.journeys && this.currentUser.journeys.length) || this.currentEdition.show_generic_journeys) 
      },
      ...mapState({
        showJourney: state => state.journeys.showJourney,
        showJourneys: state => state.journeys.showJourneys,
        selectedJourney: state => state.journeys.selectedJourney,
        menuOpen: state => state.menuOpen
      }),
      ...mapGetters(["currentUser", "currentEdition"])
    },
    methods: {
      close() {
        if (this.showJourneys) {
          this.$store.commit("setShowJourneys", false);
        }
        if (this.showJourney) {
          this.$store.commit("setShowJourney", false);
        }
      },
      handleMenuState(event) {
        if (this.menuOpen) {
          if (event.target.id !== "profile-menu-trigger") {
            this.$store.commit("setMenuOpen", null);
          }
        }
      }
    }
  }
</script>
